import { Template } from '@typings/template';
import React, { useEffect } from 'react';
import cls from 'classnames';
import refresh from './refresh';
import Card from '../Card';
import style from './style.scss';

interface Props {
  list: Template[];
}

export default function CardList(props: Props) {
  const { list } = props;
  useEffect(() => {
    refresh({
      list,
      card: '.template-card',
      info: '.template-info',
      container: '.card_container',
    });
  }, [list]);
  return (
    <div className={cls('card_container', style.container)}>
      {list.map(item => (
        <Card element={item} key={item.web_id} />
      ))}
    </div>
  );
}
